'use client';

import { ShareModal } from '@/components/ShareModal/ShareModal';
import { createContext, useCallback, useMemo, useState } from 'react';

interface ShareContextType {
	onOpen: ({
		conversationId,
		url,
	}: { conversationId?: string; url?: string }) => void;
	onClose: () => void;
}

export const ShareContext = createContext<ShareContextType>({
	onOpen: () => {},
	onClose: () => {},
});

export function ShareProvider({
	children,
}: { readonly children: React.ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);
	const [conversationId, setConversationId] = useState<string>('');
	const [shareUrl, setShareUrl] = useState<string | null>(null);

	const onOpen = useCallback(
		({ conversationId, url }: { conversationId?: string; url?: string }) => {
			setIsOpen(true);
			conversationId && setConversationId(conversationId);
			url && setShareUrl(url);
		},
		[],
	);

	const onClose = useCallback(() => {
		setIsOpen(false);
		setConversationId('');
		setShareUrl(null);
	}, []);

	const value = useMemo(
		() => ({
			onOpen,
			onClose,
		}),
		[onOpen, onClose],
	);

	return (
		<ShareContext.Provider value={value}>
			{children}
			<ShareModal
				isOpen={isOpen}
				onClose={onClose}
				url={shareUrl ? shareUrl : `/conversations/${conversationId}`}
			/>
		</ShareContext.Provider>
	);
}
